
import { defineComponent } from 'vue';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonMenuButton, IonButton, IonIcon, IonSpinner } from '@ionic/vue';
import { refreshOutline, addOutline, timeOutline } from 'ionicons/icons';
import { leadApi, loadMeta, STAGE_COLORS, optionColor, stageLabel, formatDateTime, formatMoney } from '../../salesLeads';

export default defineComponent({
  name: 'SalesLeads',
  components: { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonMenuButton, IonButton, IonIcon, IonSpinner },
  data() {
    return {
      meta: null as any,
      leads: [] as any[],
      summary: {} as any,
      hasPrevious: false,
      scope: window.localStorage.getItem('sales_lead_scope') || 'mine',
      status: 'Open',
      stage: '',
      search: '',
      followUp: '',
      page: 1,
      hasMore: false,
      loading: false,
      refreshOutline, addOutline, timeOutline,
    };
  },
  computed: {
    scopes(): { key: string; label: string }[] {
      const list = [{ key: 'mine', label: 'My leads' }];
      if (this.meta && (this.meta.user.has_team || this.meta.user.full_access)) {
        list.push({ key: 'team', label: 'Team' });
      }
      if (this.hasPrevious) {
        list.push({ key: 'previous', label: 'Transferred' });
      }
      if (this.meta && this.meta.user.full_access) {
        list.push({ key: 'all', label: 'All' });
      }
      return list;
    },
    stageOptions(): string[] {
      return this.meta ? this.meta.stages : [];
    },
  },
  async created() {
    try {
      this.meta = await loadMeta();
    } catch (e) {
      this.meta = null;
    }
    this.reload();
  },
  methods: {
    label: stageLabel,
    format: formatDateTime,
    money: formatMoney,
    stageColor(stage: string) {
      return STAGE_COLORS[stage] || '#64748b';
    },
    priorityColor(p: string) {
      return optionColor(this.meta, 'priority', p);
    },
    setScope(scope: string) {
      this.scope = scope;
      window.localStorage.setItem('sales_lead_scope', scope);
      this.reload();
    },
    setFilter(followUp: string, status: string) {
      this.followUp = followUp;
      this.status = status;
      this.reload();
    },
    reload() {
      this.page = 1;
      this.leads = [];
      this.fetch();
    },
    loadMore() {
      this.page++;
      this.fetch();
    },
    fetch() {
      this.loading = true;
      leadApi('list', {
        scope: this.scope, status: this.status, stage: this.stage, search: this.search,
        follow_up: this.followUp, page: this.page,
      }, true).then(response => {
        const data = response.data;
        this.leads = this.page === 1 ? data.leads.data : this.leads.concat(data.leads.data);
        this.hasMore = data.leads.current_page < data.leads.last_page;
        this.summary = data.summary;
        this.hasPrevious = data.has_previous;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
  },
});
